import { useState } from "react";

enum DeviceTypeEnum {
  WEB = "web",
  MOBILE = "mobile",
  TABLET = "tablet",
  UNKNOWN = "unknown"
}

export const useDeviceType = () => {
  const [deviceType] = useState<DeviceTypeEnum>(DeviceTypeEnum.WEB);

  const isMobile = false;
  const isTablet = false;
  const isWeb = true;

  return { deviceType, DeviceTypeEnum, isMobile, isTablet, isWeb };
};
